interface PromiseResolvers<T> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
}

interface PromiseConstructorWithResolvers extends PromiseConstructor {
  withResolvers?: <T>() => PromiseResolvers<T>;
}

export function installRuntimeCompatibility(): void {
  const promiseConstructor = Promise as PromiseConstructorWithResolvers;
  if (promiseConstructor.withResolvers) return;

  promiseConstructor.withResolvers = <T>(): PromiseResolvers<T> => {
    let resolve!: PromiseResolvers<T>['resolve'];
    let reject!: PromiseResolvers<T>['reject'];
    const promise = new Promise<T>((promiseResolve, promiseReject) => {
      resolve = promiseResolve;
      reject = promiseReject;
    });

    return { promise, resolve, reject };
  };
}

installRuntimeCompatibility();
